export default "__VITE_ASSET__d80916f8__"